import { Injectable } from '@angular/core';
import { BpmnModelHelper } from '@edp-pmf/bpmn-model';

@Injectable()

export class ProcessDeUtil {
  
    public funcId: string;
    constructor() { }

    static GenerateElementId(): string {
      return BpmnModelHelper.GenerateElementId();
    }
    /**
     * 创建内码
     */
    static createNM() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
    }

    static initVariableType(value): string {
        if (value) {
            if (value.length >= 8 && value.slice(0, 8) === `{"expr":`) {
                return 'expression';
            } else {
                return 'constant';
            }
        } else {
            return 'variable';
        }
    }

    getProcessDesignerRouter() {
        const url = 'processList';
        return url;
    }
    // 获取流程分类webapi
    getFlowFormWebApi() {
        return '/api/runtime/wf/v1.0/flowForm';
    }
    // 获取参数列表webapi
    getFormalParametersWebApi() {
        return '/api/runtime/wf/v1.0/formalParameter';
    }
    // 获取运行时元数据webapi
    getMetaDataRUWebApi() {
        return '/api/runtime/lcm/v1.0/rt-metadatas/';
    }
    // 获取流程构件webapi
    getBizComponentsWebApi() {
        return '/api/runtime/wf/v1.0/bizComponent';
    }
    // 基于流程分类获取表单定义
    getExcuteFormsWebApi() {
        return '/api/runtime/wf/v1.0/excuteForm';
    }
    // 获取设计时流程定义WebAPi
    getProcessDefinitionWebApi() {
        return '/api/runtime/wf/v1.0/dtProcDefs';
    }

    // 判断是否允许删除流程定义的api
    getCheckExistActiveProcDefApi() {
        return '/api/runtime/wf/v1.0/procDefs/checkExistActiveProcDef';
    }
    /**
     * 获取业务活动webApi
     */
    getBizActivityWebApi(ffId: string) {
        return `/api/runtime/wf/v1.0/bizActivity?flowFormKey=${ffId}`;
    }

    getProcDefKeyWebApi() {
        return '/api/runtime/wf/v1.0/procDefs/processDefinitionKeys';
    }
    /**
     * 发布流程api
     */
    deployWebApi() {
        return '/api/runtime/wf/v1.0/procDefs/deploy';
    }
    /**
     * 保存流程api
     */
    saveWebApi() {
        return '/api/runtime/wf/v1.0/DTProcessDefinitions/SaveBpmnModel';
    }
    /**
     * 获取审批动作webapi
     */
    getApprovalActionWebApi() {
        return '/api/runtime/wf/v1.0/approvalAction';
    }

    /**
     * 获取运行时流程定义WebAPi
     */
    getRTProcessDefinitionWebApi() {
        return '/api/runtime/wf/v1.0/procDefs';
    }

    getValue(data: any, code: string): string {
        if (!code) {
            return '';
        }
        let resultVal = '';
        if (code.indexOf('.') === -1) {
            resultVal = data[code];
        } else {
            resultVal = code.split('.').reduce((obj, key) => {
                if (obj) {
                    return obj[key];
                } else {
                    return null;
                }
            }, data);
        }
        return resultVal;
    }
    /**
     * 转换
     * @param jsonObj Object
     */
    toUpperCase(jsonObj: Object): any {
        if (typeof (jsonObj) === 'object') {
            for (const key of Object.keys(jsonObj)) {
                jsonObj[key.substring(0, 1).toUpperCase() + key.substring(1)] = jsonObj[key];
                delete (jsonObj[key]);
            }
        }
        return jsonObj;
    }
    toLowCase(jsonObj: Object): any {
        if (typeof (jsonObj) === 'object') {
            for (const key of Object.keys(jsonObj)) {
                if ((key.substring(0, 1).toLowerCase() + key.substring(1)) !== key) {
                    jsonObj[key.substring(0, 1).toLowerCase() + key.substring(1)] = jsonObj[key];
                    delete (jsonObj[key]);
                }
            }
        }
        return jsonObj;
    }
}
